import {MarketLevel} from './market-level';
import {BaseModelMicroService} from './base-model-micro-service';

export class MarketLevelRef extends BaseModelMicroService {
    name: string;
    levelRank: number;

    constructor(pMarketLevel?: MarketLevel) {
        super();
        if (pMarketLevel){
            this.id = pMarketLevel.Id;
            this.name = pMarketLevel.MarketLevelName;
            this.levelRank = pMarketLevel.Rank;
        }
    }
}